/**
 * Canonical destinations the user is taken to when they tap a tile.
 */
export const NEXTX_BASE = "https://go.nextx.com.au";

export const NEXTX_LINKS = {
  // Outstanding shipments use the same Shipments page in NextX (filtered to in-transit/shipped),
  // closest standing view here is the Pending Shipments saved view.
  shippingOutstanding: `${NEXTX_BASE}/shipments?viewId=120&viewName=Pending%20Shipments`,
  shippingPending: `${NEXTX_BASE}/shipments?viewId=120&viewName=Pending%20Shipments`,
  shippingReturns: `${NEXTX_BASE}/shipments?viewId=201&viewName=Pending%20Returns`,
  shippingLifecycle: `${NEXTX_BASE}/shipment-lifecycle-requests?viewId=204&viewName=Pending`,
} as const;
